export default __webpack_public_path__ + "78b8005afdf9889508069be3bb379096.woff";